import { Link } from 'react-router-dom';

const pageLinks = [
  { label: 'Home', href: '/' },
  { label: 'Carpet Installation', href: '/services/carpet' },
  { label: 'About Value Carpet', href: '/about' },
  { label: 'Freehold, NJ', href: '/location/freehold-nj' },
];

const services = [
  'Carpet Installation',
  'Hardwood Flooring',
  'Laminate Flooring',
  'Vinyl Flooring',
  'Floor Replacement & Repairs',
  'Marine & Specialty Carpet',
];

const socials = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/valuecarpetinc', label: 'Facebook' },
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/valuecarpetinc', label: 'Instagram' },
  { icon: 'ri-tiktok-fill', href: 'https://www.tiktok.com/@valuecarpet01', label: 'TikTok' },
  { icon: 'ri-pinterest-fill', href: 'https://www.pinterest.com/valuecarpetinc/', label: 'Pinterest' },
  { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/@valuecarpet8930', label: 'YouTube' },
];

export default function Footer() {
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#111111' }}>
      {/* Pre-footer band */}
      <div className="border-b border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm font-medium tracking-wide">
            Licensed &amp; Insured &nbsp;·&nbsp; Residential &amp; Commercial &nbsp;·&nbsp; Freehold, NJ
          </p>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="nofollow noreferrer"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer"
              >
                <i className={`${s.icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://e2bzbtvuvmf.exactdn.com/wp-content/uploads/2022/10/logo.png"
              alt="Value Carpet Inc"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-white/45 text-sm leading-relaxed mb-8">
              Specialty flooring installation for residential and commercial spaces in New Jersey. Built to last, designed to impress.
            </p>
            <div className="gold-line" />
          </div>

          {/* Pages */}
          <div>
            <h4 className="text-white/70 font-semibold text-xs uppercase tracking-widest mb-6">Pages</h4>
            <ul className="space-y-3.5">
              {pageLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/45 hover:text-gold text-sm transition-colors leading-relaxed"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white/70 font-semibold text-xs uppercase tracking-widest mb-6">Services</h4>
            <ul className="space-y-3.5">
              {services.map((s) => (
                <li key={s}>
                  <Link
                    to="/services/carpet"
                    className="text-white/45 hover:text-gold text-sm transition-colors"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/70 font-semibold text-xs uppercase tracking-widest mb-6">Contact</h4>
            <ul className="space-y-5">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-gold text-sm"></i>
                </span>
                <a
                  href="https://maps.google.com/?q=8+Tuscan+Dr,+Freehold,+NJ+07728"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/45 hover:text-gold text-sm transition-colors leading-relaxed"
                >
                  8 Tuscan Dr<br />Freehold, NJ 07728
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-gold text-sm"></i>
                </span>
                <div>
                  <a href="tel:1-866-732-2966" className="text-white/45 hover:text-gold text-sm transition-colors block">
                    1-866-732-2966 (Toll Free)
                  </a>
                  <a href="tel:732-577-1496" className="text-white/45 hover:text-gold text-sm transition-colors block mt-1">
                    732-577-1496 (Local)
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-gold text-sm"></i>
                </span>
                <a
                  href="mailto:sales@valuecarpetinc.com"
                  className="text-white/45 hover:text-gold text-sm transition-colors"
                >
                  sales@valuecarpetinc.com
                </a>
              </li>
              <li className="pt-2">
                <button
                  onClick={scrollToContact}
                  className="bg-gold text-charcoal text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer"
                >
                  Request Consultation
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">
            &copy; {new Date().getFullYear()} Value Carpet Inc. All Rights Reserved.
          </p>
          <p className="text-white/20 text-xs">
            Specialty Flooring Experts &nbsp;·&nbsp; New Jersey
          </p>
        </div>
      </div>
    </footer>
  );
}
